import { defineMessages } from 'react-intl';

const messages = defineMessages({
  overview: {
    id: 'premium-menu.basic-info.menu-item.overview',
    defaultMessage: 'Overview',
  },
  studies: {
    id: 'premium-menu.basic-info.menu-item.studies',
    defaultMessage: 'Studies',
  },
  studentLife: {
    id: 'premium-menu.basic-info.menu-item.studentLife',
    defaultMessage: 'Student Life',
  },
  admissions: {
    id: 'premium-menu.basic-info.menu-item.admissions',
    defaultMessage: 'Admissions',
  },
  costs: {
    id: 'premium-menu.basic-info.menu-item.costs',
    defaultMessage: 'Costs',
  },
  transferInfo: {
    id: 'premium-menu.basic-info.menu-item.transferInfo',
    defaultMessage: 'Transfer Info',
  },
  choose: {
    id: 'premium-menu.basic-info.menu-item.choose',
    defaultMessage: 'Choose an item to edit',
  },

  // overview
  openingStatement: {
    id: 'premium-menu.basic-info.menu-item.openingStatement',
    defaultMessage: 'Opening Statement',
  },
  website: {
    id: 'premium-menu.basic-info.menu-item.website',
    defaultMessage: 'Website',
  },
  schoolType: {
    id: 'premium-menu.basic-info.menu-item.schoolType',
    defaultMessage: 'School Type',
  },
  undergraduateEnrollment: {
    id: 'premium-menu.basic-info.menu-item.undergraduateEnrollment',
    defaultMessage: 'Undergraduate Enrollment',
  },
  studentFacultyRatio: {
    id: 'premium-menu.basic-info.menu-item.studentFacultyRatio',
    defaultMessage: 'Student / Faculty Ratio',
  },
  campusSurroundings: {
    id: 'premium-menu.basic-info.menu-item.campusSurroundings',
    defaultMessage: 'Campus Surroundings',
  },
  testScores: {
    id: 'premium-menu.basic-info.menu-item.testScores',
    defaultMessage: 'Test Scores',
  },
  gpa: {
    id: 'premium-menu.basic-info.menu-item.gpa',
    defaultMessage: 'GPA',
  },
  contactInformation: {
    id: 'premium-menu.basic-info.menu-item.contactInformation',
    defaultMessage: 'Contact Information',
  },

  // studies
  studentRetention: {
    id: 'premium-menu.basic-info.menu-item.studentRetention',
    defaultMessage: 'Student Retention %',
  },
  graduationRate: {
    id: 'premium-menu.basic-info.menu-item.graduationRate',
    defaultMessage: 'Old Graduation Rate Message',
  },
  graduationRate4: {
    id: 'premium-menu.basic-info.menu-item.graduationRate4',
    defaultMessage: '4 Year Graduation Rate %',
  },
  graduationRate6: {
    id: 'premium-menu.basic-info.menu-item.graduationRate6',
    defaultMessage: '6 Year Graduation Rate %',
  },
  topAreasOfStudy: {
    id: 'premium-menu.basic-info.menu-item.topAreasOfStudy',
    defaultMessage: 'Top Areas of Study',
  },
  studyOptions: {
    id: 'premium-menu.basic-info.menu-item.studyOptions',
    defaultMessage: 'Study Options',
  },

  // student life
  schoolSize: {
    id: 'premium-menu.basic-info.menu-item.schoolSize',
    defaultMessage: 'School Size',
  },
  nearestCity: {
    id: 'premium-menu.basic-info.menu-item.nearestCity',
    defaultMessage: 'Nearest City',
  },
  ethnicity: {
    id: 'premium-menu.basic-info.menu-item.ethnicity',
    defaultMessage: 'Ethnicity',
  },
  genderData: {
    id: 'premium-menu.basic-info.menu-item.genderData',
    defaultMessage: 'Gender Data',
  },
  ageData: {
    id: 'premium-menu.basic-info.menu-item.ageData',
    defaultMessage: 'Age Data',
  },
  housingData: {
    id: 'premium-menu.basic-info.menu-item.housingData',
    defaultMessage: 'Housing Data',
  },
  greekLife: {
    id: 'premium-menu.basic-info.menu-item.greekLife',
    defaultMessage: 'Greek Life',
  },
  services: {
    id: 'premium-menu.basic-info.menu-item.services',
    defaultMessage: 'Services',
  },
  computingResources: {
    id: 'premium-menu.basic-info.menu-item.computingResources',
    defaultMessage: 'Computing Resources',
  },
  organizations: {
    id: 'premium-menu.basic-info.menu-item.organizations',
    defaultMessage: 'Organizations',
  },
  athletics: {
    id: 'premium-menu.basic-info.menu-item.athletics',
    defaultMessage: 'Athletics',
  },

  // admissions
  acceptanceRate: {
    id: 'premium-menu.basic-info.menu-item.acceptanceRate',
    defaultMessage: 'Acceptance Rate',
  },
  importantPolicies: {
    id: 'premium-menu.basic-info.menu-item.importantPolicies',
    defaultMessage: 'Important Policies',
  },
  deadlines: {
    id: 'premium-menu.basic-info.menu-item.deadlines',
    defaultMessage: 'Deadlines',
  },
  fees: {
    id: 'premium-menu.basic-info.menu-item.fees',
    defaultMessage: 'Fees',
  },
  applicationRequirements: {
    id: 'premium-menu.basic-info.menu-item.applicationRequirements',
    defaultMessage: 'Application Requirements',
  },
  recommendedCourses: {
    id: 'premium-menu.basic-info.menu-item.recommendedCourses',
    defaultMessage: 'Recommended Courses',
  },
  applicationFactors: {
    id: 'premium-menu.basic-info.menu-item.applicationFactors',
    defaultMessage: 'Application Factors',
  },
  invalidError: {
    id: 'premium-menu.basic-info.testScores.invalid',
    defaultMessage: 'Invalid value.',
  },

  // costs
  averageNetPrices: {
    id: 'premium-menu.basic-info.menu-item.averageNetPrices',
    defaultMessage: 'Average Net Prices',
  },
  receivingAid: {
    id: 'premium-menu.basic-info.menu-item.receivingAid',
    defaultMessage: '% Receiving Aid',
  },
  averageAmountOfAid: {
    id: 'premium-menu.basic-info.menu-item.averageAmountOfAid',
    defaultMessage: 'Average Amount of Aid',
  },
  costItems: {
    id: 'premium-menu.basic-info.menu-item.costItems',
    defaultMessage: 'Items related to cost',
  },

  // transfer information
  transferWebsite: {
    id: 'premium-menu.basic-info.menu-item.transferWebsite',
    defaultMessage: 'Transfer Website',
  },
  supportWebsite: {
    id: 'premium-menu.basic-info.menu-item.transferInfo.supportWebsite',
    defaultMessage: 'Transfer Support Services Website',
  },
  financialAidInfoWebsite: {
    id: 'premium-menu.basic-info.menu-item.transferInfo.financialAidInfoWebsite',
    defaultMessage: 'Financial Aid Info Website',
  },
  transferOverview: {
    id: 'premium-menu.basic-info.menu-item.transferOverview',
    defaultMessage: 'Transfer Overview',
  },
  transferAdmissionsContact: {
    id: 'premium-menu.basic-info.menu-item.transferAdmissionsContact',
    defaultMessage: 'Transfer Admissions Contact Information',
  },
  creditTransferInfoWebsite: {
    id: 'premium-menu.basic-info.menu-item.creditTransferInfoWebsite',
    defaultMessage: 'Credit Transfer Info Website',
  },
  transferAcademicResidency: {
    id: 'premium-menu.basic-info.menu-item.transferAcademicResidency',
    defaultMessage: 'Academic Residency',
  },
  transferApplicationRequirements: {
    id: 'premium-menu.basic-info.menu-item-transferApplicationRequirements',
    defaultMessage: 'Transfer Application Requirements',
  },
  transferCreditPolicies: {
    id: 'premium-menu.basic-info.menu-item-transferCreditPolicies',
    defaultMessage: 'Transfer Credit Policies',
  },
  transferArticulationAgreements: {
    id: 'premium-menu.basic-info.menu-item.transferArticulationAgreements',
    defaultMessage: 'Articulation Agreements',
  },
  dualAdmissionsPrograms: {
    id: 'premium-menu.basic-info.menu-item.dualAdmissionsPrograms',
    defaultMessage: 'Dual Admissions Programs',
  },
  collegeSystems: {
    id: 'premium-menu.basic-info.menu-item.collegeSystems',
    defaultMessage: 'College Systems',
  },
  transferCreditCap: {
    id: 'premium-menu.basic-info.menu-item.transferCreditCap',
    defaultMessage: 'Transfer Credit Cap',
  },
  transferCreditsNotAccepted: {
    id: 'premium-menu.basic-info.menu-item.transferCreditsNotAccepted',
    defaultMessage: 'Types of Transfer Credits Not Accepted',
  },
  transferScholarshipAvailability: {
    id: 'premium-menu.basic-info.menu-item.transferScholarshipAvailability',
    defaultMessage: 'Scholarship Availability for Transfers',
  },
  transferUndergraduateStudents: {
    id: 'premium-menu.basic-info.menu-item.transferUndergraduateStudents',
    defaultMessage: 'Total Number Of Undergraduate Transfer Students',
  },
  transferEightYearGradRate: {
    id: 'premium-menu.basic-info.menu-item.transferEightYearGradRate',
    defaultMessage: '8-Year Graduation Rate for Students Who Have Transferred In',
  },
  transferEnrollmentTerms: {
    id: 'premium-menu.basic-info.menu-item.transferEnrollmentTerms',
    defaultMessage: 'Enrollment Terms',
  },

  // Basic Info Component
  basicInfoHeader: {
    id: 'college-profile-edit.basic-info-component.header',
    defaultMessage: 'College overview, studies, student life, admissions, and cost information is now managed through Peterson’s.',
  },
  basicInfoSubHeader: {
    id: 'college-profile-edit.basic-info-component.subHeader',
    defaultMessage: 'Updates are made available in Naviance on a quarterly basis.',
  },
  basicInfoLinkText: {
    id: 'college-profile-edit.basic-info-component.linkText',
    defaultMessage: 'Request updates to your profile’s basic info through Peterson’s.',
  },
});

export default messages;
